import type { RouteParamsRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { PublicPostContentObjectDataObject } from 'models/service';

export const getPublicPost = async ({ routeParams: { id } }: RouteParamsRequest<{ id: string }>) =>
  apiClient.get<PublicPostContentObjectDataObject, ApiClientResponse<PublicPostContentObjectDataObject>>(
    routes.posts.get(id),
  );
